import FieldWrapper from '../fieldWrapper';
import CleanInput from '../../cleanInput';

export const ReduxFormCleanInput = FieldWrapper(CleanInput);
